import styled, { css } from 'styled-components'

export const Item = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  align-items: center;
  display: flex;
  justify-content: center;
`
